import Styles from './styles.module.scss';

import type { UserModel } from '@/features/Shared/users/model/types/users.model';

import { formatInitials } from '@/app/utils/strings';

interface UserAvatarProps {
	user?: UserModel;
}

export const UserAvatar = ({ user }: UserAvatarProps) => {
	const name = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() || '';

	return (
		<div className={Styles.userContainer}>
			<div className={Styles.avatar}>
				<span>{formatInitials(name)}</span>
			</div>
			<span>{name}</span>
		</div>
	);
};
